// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

import { InvalidRequest } from '../../error'

export const validateConversationsReducerData = data =>
  data.forEach(
    ({ id, name, lastReadTime, lastStaffReadTime, archived, isCityBased }) => {
      if (
        typeof id !== 'number' || // Always required
        ['undefined', 'string'].indexOf(typeof name) === -1 ||
        ['undefined', 'number'].indexOf(typeof lastReadTime) === -1 ||
        ['undefined', 'number'].indexOf(typeof lastStaffReadTime) === -1 ||
        ['undefined', 'boolean'].indexOf(typeof archived) === -1 ||
        ['undefined', 'boolean'].indexOf(typeof isCityBased) === -1
      ) {
        throw new InvalidRequest('Invalid conversation data')
      }
    },
  )



// WEBPACK FOOTER //
// ./src/shared/websockets/chat/validations.js